// extracted by mini-css-extract-plugin
module.exports = {"SocialLinks":"styles_SocialLinks__05yci","text":"styles_text__2i0JZ"};